import axios from 'axios';

export const getKBDocLinkAndOpen = async (
  documentId: string,
  pageNum: number,
  auth: any,
  setBlockedModalOpen: (arg: boolean) => void
) => {
  try {
    // setPreLoading(true);
    const presignedUrl = await axios.post(
      `${process.env.REACT_APP_KORU_API}/get-presigned-url?type=getDocument`,
      {
        documentId: documentId
      },
      auth
    );
    const urlWithPageNum = presignedUrl.data.url + `#page=${pageNum}`;
    const popup = window.open(urlWithPageNum, '_blank');
    const blocked =
      !popup || popup.closed || typeof popup.closed === 'undefined';
    if (blocked) {
      setBlockedModalOpen(true);
    }
    // setPreLoading(false);
  } catch (e) {
    const error = e as Error;
    console.log('error getting doc', error.message);
  }
};
